import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, XIcon } from 'lucide-react';
import { audienceFor, audienceNotFor } from '../data/content';
export function AudienceSection() {
  return <section className="w-full bg-blush px-5 py-12 sm:py-20" data-id="element-10" data-mp="s031dydi8sms">
      <div className="mx-auto grid max-w-5xl gap-6 md:grid-cols-2" data-id="element-11" data-mp="ryi80c2xffqi">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.2
      }} transition={{
        duration: 0.5
      }} className="rounded-2xl border border-line bg-surface p-6 sm:p-8" data-id="element-12" data-mp="wycsnxw3z934">
          <h3 className="mb-6 text-lg font-bold text-primary-strong sm:text-xl" data-id="element-13" data-mp="98il9vuk6cq9">
            Este método es para vos si…
          </h3>
          <ul className="space-y-4" data-id="element-14" data-mp="3cqtpcabnyquk">
            {audienceFor.map(item => <li key={item} className="flex items-start gap-3" data-id="element-15" data-mp="3cqah5lbtfgtq">
                <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-primary/15 text-primary" data-id="element-16" data-mp="3hp4zkm5vf3db">
                  <CheckIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-17" data-mp="14aauxbf59ppw" />
                </span>
                <span className="text-sm leading-relaxed text-foreground/85" data-id="element-18" data-mp="zc9c8rlmrsey">{item}</span>
              </li>)}
          </ul>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.2
      }} transition={{
        duration: 0.5,
        delay: 0.1
      }} className="rounded-2xl border border-line bg-surface p-6 sm:p-8" data-id="element-19" data-mp="qje2bkl7x8iu">
          <h3 className="mb-6 text-lg font-bold text-foreground sm:text-xl" data-id="element-20" data-mp="bldbv633zow3">No es para vos si…</h3>
          <ul className="space-y-4" data-id="element-21" data-mp="7lbjxon6e9u0">
            {audienceNotFor.map(item => <li key={item} className="flex items-start gap-3" data-id="element-22" data-mp="7mwc57m0pgop">
                <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-red-100 text-red-500" data-id="element-23" data-mp="25zmnzjyp1j7w">
                  <XIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-24" data-mp="21wqdkgjb4tf1" />
                </span>
                <span className="text-sm leading-relaxed text-muted" data-id="element-25" data-mp="3vf76pl1al1b5">{item}</span>
              </li>)}
          </ul>
        </motion.div>
      </div>
    </section>;
}